// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Format = require("bs-platform/lib/js/format.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var BigInteger = require("big-integer");

function sign(x) {
  if (Caml_obj.caml_greaterthan(x, BigInteger.zero)) {
    return 1;
  } else if (x.equals(BigInteger.zero)) {
    return 0;
  } else {
    return -1;
  }
}

function div_rem(a, b) {
  var q_r = a.divmod(b);
  return /* tuple */[
          q_r.quotient,
          q_r.remainder
        ];
}

function div(a, b) {
  return div_rem(a, b)[0];
}

function ediv_rem(a, b) {
  var match = div_rem(a, b);
  var r = match[1];
  var q = match[0];
  if (sign(r) >= 0) {
    return /* tuple */[
            q,
            r
          ];
  } else if (sign(b) >= 0) {
    return /* tuple */[
            q.prev(),
            r.add(b)
          ];
  } else {
    return /* tuple */[
            q.next(),
            r.subtract(b)
          ];
  }
}

function fdiv(a, b) {
  return div_rem(a, b)[0];
}

function cdiv(a, b) {
  var match = div_rem(a, b);
  var q = match[0];
  if (match[1].equals(BigInteger.zero)) {
    return q;
  } else {
    return q.next();
  }
}

function ediv(a, b) {
  if (sign(b) >= 0) {
    return div_rem(a, b)[0];
  } else {
    return cdiv(a, b);
  }
}

function erem(a, b) {
  var r = a.mod(b);
  if (sign(r) >= 0) {
    return r;
  } else {
    return r.add(b.abs());
  }
}

function pp_print(f, x) {
  return Format.pp_print_string(f, x.toString());
}

function compare(a, b) {
  if (a.gt(b)) {
    return 1;
  } else if (a.lt(b)) {
    return -1;
  } else {
    return 0;
  }
}

exports.sign = sign;
exports.div_rem = div_rem;
exports.div = div;
exports.ediv_rem = ediv_rem;
exports.fdiv = fdiv;
exports.cdiv = cdiv;
exports.ediv = ediv;
exports.erem = erem;
exports.pp_print = pp_print;
exports.compare = compare;
/* Format Not a pure module */
